module.exports = __webpack_public_path__ + "static/media/vahan-logo-outline.f88f3785.svg";